import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveContact = async (uuid: string) => {
  const response = await CustomAxios.post(`contacts/${uuid}/archive`);
  return response.data;
};

interface UseArchiveContactProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveContact({ uuid, onSuccessCallback }: UseArchiveContactProps) {
  return useMutation({
    mutationFn: () => archiveContact(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allContacts, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the contact. Please try again and contact support if the problem persists.');
      }
    },
  });
}
